export default __webpack_public_path__ + "static/media/cs_icon_05.93be0491.png";